import type { Language } from "@heredajo/schema";
import { t } from "../lib/strings.js";

interface Props {
  lang: Language;
}

export function About({ lang }: Props): JSX.Element {
  const s = t(lang);
  return (
    <div className="max-w-3xl mx-auto px-4 py-8 prose-diary">
      <h1 className="font-serif text-3xl mb-4">{s.aboutTitle}</h1>
      <p className="mb-4">{s.aboutIntro}</p>
      <p className="mb-4">
        {s.aboutDigitizedBy.replace(/onb\.ac\.at\.?$/, "")}
        <a className="underline" href="https://www.onb.ac.at/" target="_blank" rel="noreferrer">
          onb.ac.at
        </a>
        .
      </p>
      <p className="mb-4">{s.aboutQualityNote}</p>
      <p className="mb-4 text-ink-muted text-sm">{s.aboutAttributionFooter}</p>
    </div>
  );
}
